import { Link } from "react-router-dom";
import TagPill from "@/components/base/TagPill";

interface CompareCardProps {
  id: string;
  title: string;
  category: string;
  summary: string;
  coverImage: string;
  leftName: string;
  rightName: string;
  heat: number;
  date: string;
}

export default function CompareCard({
  id,
  title,
  category,
  summary,
  coverImage,
  leftName,
  rightName,
  heat,
  date,
}: CompareCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/compare/${id}`} className="block h-48 w-full overflow-hidden">
        <img
          src={coverImage}
          alt={`${title}对比示意图`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </Link>
      <div className="flex flex-1 flex-col p-5">
        <div className="flex flex-wrap items-center gap-2">
          <TagPill variant="primary">{category}</TagPill>
          <span className="text-xs text-foreground-500">{date}</span>
        </div>
        <h2 className="mt-3 font-heading text-base font-bold leading-snug text-foreground-950">
          <Link to={`/compare/${id}`} className="transition-colors hover:text-primary-700">
            {title}
          </Link>
        </h2>
        <p className="mt-3 line-clamp-3 flex-1 text-sm leading-relaxed text-foreground-600">{summary}</p>

        <div className="mt-4 flex items-center justify-between gap-2 rounded-md bg-background-100 px-3 py-2 text-xs">
          <span className="truncate text-primary-700">{leftName}</span>
          <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-background-200 text-[10px] font-bold text-foreground-700">
            VS
          </span>
          <span className="truncate text-right text-secondary-700">{rightName}</span>
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-4 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1.5">
            <span className="flex h-4 w-4 items-center justify-center text-primary-500">
              <i className="ri-fire-line text-base" />
            </span>
            热度 {heat.toLocaleString()}
          </span>
          <Link
            to={`/compare/${id}`}
            className="inline-flex items-center gap-1 whitespace-nowrap font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            查看对比
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-s-line text-sm" />
            </span>
          </Link>
        </div>
      </div>
    </article>
  );
}